var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',{staticClass:"d-flex justify-content-center"},[_c('CCol',{attrs:{"md":"12"}},[_c('CCard',[_c('CCardBody',[_c('CRow',{staticClass:"d-flex justify-content-center"},[_c('CImg',{staticClass:"img-fluid",attrs:{"src":"../../img/cant.jpeg","block":""}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }